/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `20FT_CONTAINER` - CONTAINER_20FT
 * * `40FT_CONTAINER` - CONTAINER_40FT
 * * `CS` - CURTAIN_SIDE
 * * `WF` - WALKING_FLOOR
 * * `BT` - BOX_TRAILER
 */
export type TransportMethodEnum = typeof TransportMethodEnum[keyof typeof TransportMethodEnum];


export const TransportMethodEnum = {
  '20FT_CONTAINER': '20FT_CONTAINER',
  '40FT_CONTAINER': '40FT_CONTAINER',
  CS: 'CS',
  WF: 'WF',
  BT: 'BT',
} as const;
